import { singleRequestPromiseFactory } from '@beecode/msh-node-util/lib/cache/single-request-promise';
import { Injectable } from '@angular/core';
import { ClientGuidService } from './clientGuid.service';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  authMSUrl = environment.authMSServerUrl;
  singleRequestPromiseRefreshToken = singleRequestPromiseFactory(async () => {
    const clientGuid = await this.clientGuidService.getOrCreate();
    const oldRefreshToken = this.authService.getRefreshToken();
    const { accessToken, refreshToken } = (await this.refreshToken(clientGuid, oldRefreshToken))[0];
    this.authService.setToken(accessToken);
    this.authService.setRefreshToken(refreshToken);
    return accessToken;
  });
  constructor(
    private clientGuidService: ClientGuidService,
    private authService: AuthService,
    private http: HttpClient,
  ) {}

  async getRefreshToken(): Promise<string> {
    return this.singleRequestPromiseRefreshToken.promise().then((result) => {
      return result;
    });
  }
  async refreshToken(
    clientGuid: string,
    refreshToken: string,
  ): Promise<[{ accessToken: string; refreshToken: string }]> {
    const url = '/refresh-token';
    const headers = new HttpHeaders({ 'grant-type': 'refresh-token' });
    const { data: accessToken } = await this.http
      .post<{ data: [{ accessToken: string; refreshToken: string }] }>(
        `${this.authMSUrl}${url}`,
        { refreshToken, clientGuid },
        { headers },
      )
      .toPromise();
    if (!accessToken) throw new Error('Access token not found');
    return accessToken;
  }
}
